export default {"src":"/_next/static/media/paypal.f50e206a.svg","height":50,"width":50};